import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';

import { PageState } from 'app/store/models/page.model';
import { setBannerComponent } from 'app/store/actions/page.action';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
})
export class AboutComponent implements OnInit {
  ngOnInit() {}
}
